<ion-button
  largeFont
  *ngFor="let button of callcardToolButtons"
  [class.ion-hide]="!button.show"
  [color]="button.color"
  [disabled]="button.isDisabled"
  expand="block"
  fill="solid"
  (click)="button.click(card)"
>
  <ion-icon [icon]="button.icon" slot="start" size="large"></ion-icon>
  <span>{{ button.dontTranslate ? button.text : (button.text | translate) }}</span>
</ion-button>
